import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";

const AdvancedFormTemplate = () => {
  const [isDark, setIsDark] = useState(false);
  const [skin, setSkin] = useState("emerald");
const currentSkin =getCurrentSkin(skin)
  const { baseColor, baseShade } = currentSkin;

  const inputClass = `w-full px-4 py-2 rounded-lg text-sm border focus:outline-none focus:ring-2 ${
    isDark
      ? "bg-gray-800 text-white border-white/20 focus:ring-blue-400"
      : "bg-white text-black border-gray-300 focus:ring-blue-400"
  }`;

  const labelClass = `block mb-1 font-medium ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  return (
    <LayoutWrapper
      isDark={isDark}
      setIsDark={setIsDark}
      skin={skin}
      setSkin={setSkin}
    >
      <HeaderBar title="Create New Request" setSkin={setSkin} currentSkin={skin} />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        <form className="space-y-8">
          {/* Section: Basic Details */}
          <div>
            <h3 className="text-xl font-semibold mb-4 border-b pb-2">Basic Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Requisition No</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Date</label>
                <input type="date" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Branch</label>
                <select className={inputClass}>
                  <option>CHENNI</option>
                  <option>KARUR</option>
                  <option>ERODE</option>
                </select>
              </div>
              <div>
                <label className={labelClass}>Department</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          </div>

          {/* Section: Vehicle Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4 border-b pb-2">Vehicle Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Vehicle Code</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Vehicle Number</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Cumulative</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Head Material</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          </div>

          {/* Section: Authorization */}
          <div>
            <h3 className="text-xl font-semibold mb-4 border-b pb-2">Authorization</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>H.O.D</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Indent Reference</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Approved?</label>
                <div className="flex items-center gap-6 mt-2">
                  <label className="inline-flex items-center gap-2">
                    <input type="radio" name="approve" value="yes" className="accent-blue-500" />
                    Yes
                  </label>
                  <label className="inline-flex items-center gap-2">
                    <input type="radio" name="approve" value="no" className="accent-red-500" />
                    No
                  </label>
                </div>
              </div>
              <div>
                <label className={labelClass}>Status</label>
                <select className={inputClass}>
                  <option value="">Select Status</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </div>
          </div>

          {/* Section: Remarks */}
          <div>
            <label className={labelClass}>Remarks</label>
            <textarea rows={4} className={inputClass} placeholder="Enter any notes or comments..." />
          </div>

          {/* Submit Button */}
          <div className="text-right">
            <button
              type="submit"
              className={`px-6 py-2 text-white text-sm rounded-lg shadow ${`bg-${baseColor}-${baseShade}`} hover:bg-${baseColor}-700`}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </LayoutWrapper>
  );
};

export default AdvancedFormTemplate;
